import { Stack } from '@mui/material';
import { Copyright } from './copyright';

export function Footer() {
    return (
        <Stack pt={2} alignItems='center' width='100%'>
            <Copyright />
        </Stack>
    );
}
